// @flow

import styled from '@emotion/styled'

import Row from './Row';

const FormRow = styled(Row)`
  padding: 5px 0;
`;

export default FormRow;
